import axios from 'axios';
import { CalibrationInformation } from 'views/bluviu-nutrition/features/calibrations/types/calibration-information.type';

/**
 * Returns positional and temperature data for a site
 * @param globalSiteId
 * @returns `CalibrationInformation`
 */
export const getCalibrationInformation = async (globalSiteId: string): Promise<CalibrationInformation> => {
  const res = await axios.get<CalibrationInformation>(`ewosapi/v1/site-settings/${globalSiteId}/calibration-info`);

  return res.data;
};
